/* Bundle builder — live subtotal and multi-item add to cart. */
(function () {
  // Formats against the shop's own money_format. Don't use theme.formatMoney —
  // it falls back to a USD format when its own format string isn't set.
  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) cents = 0;
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents, format) {
    var token = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(token);
    var value;

    switch (match && match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    var out = format.replace(token, value);
    // match sc-money.js: whole amounts drop the ,00
    if (cents % 100 === 0) out = out.replace(/([,.]00)(?=\s*\S|$)/g, '');
    return out;
  }

  function init(root) {
    var format = root.dataset.moneyFormat || '{{amount_with_comma_separator}}€';
    var fmt = function (cents) {
      return money(cents, format);
    };
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-cb]'));
    var totalEl = root.querySelector('[data-bundle-total]');
    var compareEl = root.querySelector('[data-bundle-compare]');
    var saveEl = root.querySelector('[data-bundle-save]');
    var ribbon = root.querySelector('[data-bundle-ribbon]');
    var button = root.querySelector('[data-bundle-add]');
    if (!boxes.length || !button) return;

    function selected() {
      return boxes.filter(function (b) {
        return b.checked && !b.disabled;
      });
    }

    function refresh() {
      var total = 0;
      var compare = 0;
      selected().forEach(function (b) {
        total += parseInt(b.dataset.price, 10) || 0;
        compare += parseInt(b.dataset.compare, 10) || 0;
      });

      if (totalEl) totalEl.textContent = fmt(total);

      // only show the struck-through figure when something is actually discounted
      var saving = compare - total;
      if (compareEl) {
        compareEl.textContent = fmt(compare);
        compareEl.hidden = saving <= 0;
      }
      if (saveEl) saveEl.textContent = fmt(saving);
      if (ribbon) ribbon.hidden = saving <= 0;

      button.disabled = selected().length === 0;
    }

    boxes.forEach(function (b) {
      b.addEventListener('change', refresh);
    });
    refresh();

    // Coming back via the browser's back button restores the page from bfcache
    // with the button still disabled + spinning from the previous submit.
    window.addEventListener('pageshow', function () {
      button.classList.remove('is-loading');
      refresh();
    });

    /* The cart drawer is UpCart. Before, the cart drawer was SlideCart HQ. The
       theme <cart-drawer> element is not connected.
       This code adds items with an unpatched fetch function. Refer to cartFetch.
       Thus the cart app does not see the request. Refresh the drawer before you
       open it. If you do not refresh the drawer, it shows the initial cart. */
    function call(name) {
      var fn = window[name];
      if (typeof fn !== 'function') return null;
      try {
        return { value: fn() };
      } catch (e) {
        console.error('[sh-combo]', name, e);
        return { value: undefined };
      }
    }

    // The app script loads later. A quick click can occur first. Thus, wait.
    function waitFor(test, limit) {
      var deadline = Date.now() + (limit || 3000);
      return new Promise(function (resolve) {
        (function poll() {
          if (test()) return resolve(true);
          if (Date.now() >= deadline) return resolve(false);
          setTimeout(poll, 100);
        })();
      });
    }

    function hasUpcart() {
      return (
        typeof window.upcartOpenCart === 'function' ||
        typeof window.upcartRefreshCart === 'function'
      );
    }

    function openUpcart(open) {
      var refreshed = call('upcartRefreshCart') || call('upcartUpdateCart');
      Promise.resolve(refreshed && refreshed.value).then(function () {
        if (open) call('upcartOpenCart');
      });
    }

    function syncCart(open) {
      if (typeof window.seppSyncHeaderCart === 'function') window.seppSyncHeaderCart();

      if (hasUpcart()) {
        openUpcart(open);
        return;
      }

      if (typeof window.SLIDECART_UPDATE === 'function') {
        Promise.resolve(window.SLIDECART_UPDATE()).then(function () {
          if (open && typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        });
        return;
      }

      if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return;
      }

      waitFor(function () {
        return hasUpcart() || typeof window.SLIDECART_UPDATE === 'function';
      }).then(function (ready) {
        if (ready) return syncCart(open);
        if (!open) return;
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location = base + 'cart';
      });
    }

    /* The quantity-discount app block scales cart/add quantities: the buy-block form
       posts quantity=1 and the app multiplies it by the selected tile (see the note
       in sh-quantity-tiers.js). It does that by patching window.fetch, and the patch
       is global — so it also caught our add and turned "2 Stück" on the main product
       into 2 of combo row 1, which is priced per single unit here.

       Borrow an untouched fetch from a same-origin about:blank iframe. Only the top
       window gets patched, so the frame's copy reaches the network unscaled. The
       frame must stay in the document: removing it tears down its realm and the
       borrowed function stops working. */
    var rawFetch;

    function cartFetch(url, opts) {
      if (rawFetch === undefined) {
        rawFetch = null;
        try {
          var frame = document.createElement('iframe');
          frame.setAttribute('aria-hidden', 'true');
          frame.tabIndex = -1;
          frame.style.cssText =
            'position:absolute;top:0;left:0;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(frame);
          var borrowed = frame.contentWindow && frame.contentWindow.fetch;
          if (typeof borrowed === 'function') rawFetch = borrowed.bind(frame.contentWindow);
        } catch (e) {
          // cross-origin lockdown or no body yet — fall through to the patched fetch
        }
      }
      return (rawFetch || window.fetch)(url, opts);
    }

    /* One request per product. SlideCart intercepts cart/add — via fetch and XHR
       alike, adding its own ?sh_skip flag — and collapses a multi-item items[]
       payload to the first item. Measured: items[] adds 1 of 3, sequential adds 3.
       Kept sequential: the unpatched fetch above dodges SlideCart too, but syncCart
       refreshes the drawer explicitly either way. */
    function addSelected() {
      if (button.classList.contains('is-loading')) return;

      var ids = selected().map(function (b) {
        return parseInt(b.value, 10);
      });
      if (!ids.length) return;

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      button.classList.add('is-loading');
      button.disabled = true;

      ids
        .reduce(function (chain, id) {
          return chain.then(function () {
            return cartFetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: id, quantity: 1 }),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (data) {
                if (data.status) throw new Error(data.description || data.message || 'add failed');
              });
          });
        }, Promise.resolve())
        .then(function () {
          button.classList.remove('is-loading');
          refresh();
          syncCart(true);
        })
        .catch(function (err) {
          // sequential means a mid-chain failure leaves a partial cart — resync so
          // the drawer shows what's really there, rather than guessing which lines
          // were ours and removing them
          console.error('[sh-combo]', err);
          button.classList.remove('is-loading');
          refresh();
          syncCart(false);
        });
    }

    button.addEventListener('click', addSelected);
  }

  function boot() {
    document.querySelectorAll('[data-sh-combo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // theme editor re-renders sections
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sh-combo]');
    if (root) init(root);
  });
})();
